"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationErrorSource = void 0;
/**
 * Sources of invalid attributes.
 *
 * @public
 */
var ValidationErrorSource;
(function (ValidationErrorSource) {
    /**
     * The principal's attributes failed schema validation.
     */
    ValidationErrorSource["PRINCIPAL"] = "SOURCE_PRINCIPAL";
    /**
     * The resource's attributes failed schema validation.
     */
    ValidationErrorSource["RESOURCE"] = "SOURCE_RESOURCE";
})(ValidationErrorSource || (exports.ValidationErrorSource = ValidationErrorSource = {}));
//# sourceMappingURL=ValidationErrorSource.js.map